var _rect, _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRejectedPopup = function SvgRejectedPopup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 40,
    height: 48,
    rx: 5,
    stroke: "#D7D8DA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 22.634C36.1667 23.0189 36.1667 23.9811 35.5 24.366L27.25 29.1292C26.5833 29.5141 25.75 29.0329 25.75 28.2631L25.75 18.7369C25.75 17.9671 26.5833 17.4859 27.25 17.8708L35.5 22.634Z",
    fill: "#D7D8DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 49,
    r: 10,
    fill: "#FF4343",
    stroke: "#191A1B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9846 45.9948C32.7893 45.7995 32.4727 45.7995 32.2774 45.9948L29.9897 48.2825L27.702 45.9948C27.5068 45.7995 27.1902 45.7995 26.9949 45.9948C26.7997 46.1901 26.7997 46.5066 26.9949 46.7019L29.2826 48.9896L26.9949 51.2773C26.7997 51.4726 26.7997 51.7892 26.9949 51.9844C27.1902 52.1797 27.5068 52.1797 27.702 51.9844L29.9897 49.6967L32.2774 51.9844C32.4727 52.1797 32.7893 52.1797 32.9846 51.9844C33.1798 51.7892 33.1798 51.4726 32.9846 51.2773L30.6969 48.9896L32.9846 46.7019C33.1798 46.5066 33.1798 46.1901 32.9846 45.9948Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRejectedPopup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rejected-popup.fcde6a39.svg";
export { ForwardRef as ReactComponent };